(function () {
    'use strict';

    angular
        .module('app.influencerManagementLog')
        .controller('influencerManagementLogCtrl', ['$scope', '$rootScope', 'influencerManagementLogService', '$modal', 'adminService', 'TimelineService',
            function ($scope, $rootScope, influencerManagementLogService, $modal, adminService, timelineService) {
                $scope.user_id = 0;
                $scope.page_no = 1;
                $scope.page_size = 25;
                $scope.timeline = angular.copy(timelineService.logTimeline);
                $scope.timeline.forEach(function (val) {
                    val.ticked = false;
                });  
                $scope.timeline[2].ticked = true;

                var dateRange = timelineService.calculateDateRangeByLogTimeline($scope.timeline[2].value);
                $scope.from_date = dateRange.fromDate;
                $scope.to_date = dateRange.toDate;

                $scope.getAchooUsers = function () {
                    influencerManagementLogService.getAchooUsers(false)
                        .then(function (response) {
                            $scope.achooUsers = response.data;
                            $scope.achooUsers[0].ticked = true;
                        }, function (response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getAchooUsers();

                $scope.selectUser = function (user) {
                    $scope.user_id = user.id;
                    $scope.getInfluencerManagementLog();
                    $scope.getNumberOfInfluencerManagementLog();
                    $scope.getNumberOfInfluencerVerifiedAndApprovalRate();
                    $scope.getNumberOfChannelsAdded();
                }

                $scope.selectPeriod = function (period) {
                    var dateRange = timelineService.calculateDateRangeByLogTimeline(period.value);
                    $scope.from_date = dateRange.fromDate;
                    $scope.to_date = dateRange.toDate;
                    $scope.getInfluencerManagementLog();
                    $scope.getNumberOfInfluencerManagementLog();
                    $scope.getNumberOfInfluencerVerifiedAndApprovalRate();
                    $scope.getNumberOfChannelsAdded();
                }

                $scope.updatePage = function (currentPage) {
                    $scope.page_no = currentPage;
                    $scope.getInfluencerManagementLog();
                    $scope.getNumberOfInfluencerManagementLog();
                    $scope.getNumberOfInfluencerVerifiedAndApprovalRate();
                    $scope.getNumberOfChannelsAdded();
                }

                $scope.getInfluencerManagementLog = function () {
                    influencerManagementLogService.getInfluencerManagementLog($scope.user_id, $scope.from_date, $scope.to_date, $scope.page_no, $scope.page_size, true)
                        .then(function (response) {
                            $scope.influencerManagementLog = response.data;

                            $scope.influencerManagementLog.forEach(function (item) {
                                item.date = moment(item.date).format('YYYY-MM-DD hh:mm A');
                            });

                        }, function (response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getInfluencerManagementLog();

                $scope.getNumberOfInfluencerManagementLog = function () {
                    influencerManagementLogService.getNumberOfInfluencerManagementLog($scope.user_id, $scope.from_date, $scope.to_date, true)
                        .then(function (response) {
                            $scope.number = response.data;
                            $scope.pagination();
                        }, function (response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getNumberOfInfluencerManagementLog();

                $scope.getNumberOfInfluencerVerifiedAndApprovalRate = function () {
                    influencerManagementLogService.getNumberOfInfluencerVerifiedAndApprovalRate($scope.user_id, $scope.from_date, $scope.to_date, true)
                        .then(function (response) {
                            $scope.influencersVerified = response.data.influencers_verified;
                            $scope.influencersApproved = response.data.influencers_approved;
                            $scope.approvalRate = response.data.approval_rate;
                        }, function (response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getNumberOfInfluencerVerifiedAndApprovalRate();

                $scope.getNumberOfChannelsAdded = function () {
                    influencerManagementLogService.getNumberOfChannelsAdded($scope.user_id, $scope.from_date, $scope.to_date, true)
                        .then(function (response) {
                            $scope.channelsAdded = response.data;
                        }, function (response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getNumberOfChannelsAdded();

                $scope.influencerManagementLogDetailed = function (influencer_management_log_id, influencer_id) {
                    var influencerManagementLogDetailedModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/admin/influencerManagement/influencerManagementLog/influencerManagementLogDetailed/influencerManagementLogDetailed.html?app_v=deployDate',
                        controller: 'influencerManagementLogDetailedCtrl',
                    });

                    $scope.influencer_management_log_id = influencer_management_log_id;
                    $scope.influencer_id = influencer_id;
                    $scope.influencerManagementLogDetailedModalInstance = influencerManagementLogDetailedModalInstance;
                    influencerManagementLogDetailedModalInstance.result.then(function () {
                        $scope.getInfluencerManagementLog();
                        $scope.getNumberOfInfluencerManagementLog();
                        $scope.getNumberOfInfluencerVerifiedAndApprovalRate();
                        $scope.getNumberOfChannelsAdded();
                    })
                }

                $scope.pagination = function () {
                    $scope.pages = adminService.pagination($scope.number, $scope.page_size);
                };

                $scope.influencerDetails = function (influencer_id) {
                    var influencerDetailsFromInfluencerLogModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/admin/influencerManagement/influencer_management_influencers/influencers_influencer_details.html?app_v=deployDate',
                        controller: 'InfluencerDetailsCtrl'
                    });

                    $scope.influencerDetailsFromInfluencerLogModalInstance = influencerDetailsFromInfluencerLogModalInstance;
                    $scope.id = influencer_id;
                    $scope.flag = true;
                    $scope.fromInfluencerLog = true;
                    influencerDetailsFromInfluencerLogModalInstance.result.then(function () {
                        $scope.getInfluencerManagementLog();
                        $scope.getNumberOfInfluencerManagementLog();
                        $scope.getNumberOfInfluencerVerifiedAndApprovalRate();
                        $scope.getNumberOfChannelsAdded();
                    })
                };

            }
        ])
})();